module.exports = __webpack_public_path__ + "img/user.9a337fd8.svg";